import React, { useEffect, useState } from 'react';
import { Capacitor } from '@capacitor/core';

// Báo khi trên web có bản mới: so tên file JS chính đang chạy với tên file trong index.html mới nhất.
// Bản chạy trong app Android/iOS (Capacitor) dùng file đóng gói sẵn nên không kiểm tra.
const MAIN_JS_RE = /\/static\/js\/main\.[a-z0-9]+\.js/;
const CHECK_EVERY_MS = 30 * 60 * 1000;

const currentMainJs = () => {
  const el = Array.from(document.scripts).find((s) => MAIN_JS_RE.test(s.src || ''));
  const m = el && el.src.match(MAIN_JS_RE);
  return m ? m[0] : null;
};

const WebUpdateBanner = () => {
  const [hasUpdate, setHasUpdate] = useState(false);

  useEffect(() => {
    if (Capacitor.isNativePlatform()) return undefined;
    const running = currentMainJs();
    if (!running) return undefined; // chạy dev (npm start) hoặc không xác định được

    let stopped = false;
    const check = async () => {
      try {
        const res = await fetch(`/?_=${Date.now()}`, { cache: 'no-store' });
        if (!res.ok) return;
        const m = (await res.text()).match(MAIN_JS_RE);
        if (!stopped && m && m[0] !== running) setHasUpdate(true);
      } catch (e) {
        // mất mạng: bỏ qua, lần sau kiểm lại
      }
    };

    const first = setTimeout(check, 5000);
    const timer = setInterval(check, CHECK_EVERY_MS);
    const onVisible = () => { if (document.visibilityState === 'visible') check(); };
    document.addEventListener('visibilitychange', onVisible);
    return () => {
      stopped = true;
      clearTimeout(first);
      clearInterval(timer);
      document.removeEventListener('visibilitychange', onVisible);
    };
  }, []);

  if (!hasUpdate) return null;

  const reload = () => {
    // Đi qua trang làm mới: gỡ service worker/cache cũ rồi vào lại với địa chỉ mới
    window.location.href = '/lam-moi.html';
  };

  return (
    <div
      role="status"
      style={{
        position: 'fixed', left: 12, right: 12, bottom: 76, zIndex: 10000,
        background: '#065f46', color: 'white', padding: '12px 14px', borderRadius: 12,
        display: 'flex', alignItems: 'center', gap: 12, boxShadow: '0 4px 14px rgba(0,0,0,0.25)'
      }}
    >
      <span style={{ flex: 1, fontSize: '0.9rem' }}>🆕 Đã có phiên bản mới của AI Đi Chợ.</span>
      <button
        type="button"
        onClick={reload}
        style={{ background: 'white', color: '#065f46', border: 'none', borderRadius: 8, padding: '8px 12px', fontWeight: 700, cursor: 'pointer' }}
      >
        Cập nhật
      </button>
    </div>
  );
};

export default WebUpdateBanner;
